export default "__VITE_ASSET__BNepnErB__"